<template>
  <crud-list :data-list="menus">
    <template v-slot:listItem="{ listItem }">
      {{ listItem.name }}
    </template>
    <template  v-slot="{ form: item }">
      <form-menu :toCopy="item.item" :operation="item.operation" />
    </template>
  </crud-list>
</template>

<script>
import FormMenu from "../components/FormMenu.vue";
import {mapActions, mapState} from "vuex";
import CrudList from "@/core/components/CrudList";

export default {
  name: 'Menu',
  components:{
    FormMenu,
    CrudList
  },
  computed: {
    ...mapState('menus', ['menus'])
  },
  methods: {
    ...mapActions('menus', ['loadMenus']),
    ...mapActions('crudList',['loadList'])
  },
  created() {
    this.loadMenus()
  },
  updated() {
    this.loadList(this.menus)
  },
}
</script>

<style scoped>

</style>
